module.exports = __webpack_public_path__ + "img/slider_smartbook.aee8816d.png";